<template>
  <div class="chat-container" v-if="show">
    <main-title class="d-flex align-center space-between">
      <span>Chat</span>
      <button @click="callToAdmin" class="btn btn_call">{{$t('forms.call')}}</button>
    </main-title>

    <chat />
  </div>
</template>

<script>
import mainTitle from "@/components/base/mainTitle";
import chat from "@/components/chat/index";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "chat-page",
  components: {
    mainTitle,
    chat
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    ...mapGetters({
      messages: "chat/messages"
    }),
    getPhone() {
      return this.$config.project == "profy"
        ? "tel:021197537177"
        : "tel:080020297921";
    }
  },
  methods: {
    ...mapActions({
      fetch: "chat/fetch"
    }),
    callToAdmin() {
      this.$log("menu_callUs");
      window.location.href = this.getPhone;
    }
  },
  async mounted() {
    document.body.classList.toggle("body-scroll-disable");
    await this.fetch();
    this.show = true;
    this.$log("menu_chat");
  },
  beforeDestroy() {
    document.body.classList.toggle("body-scroll-disable");
  }
};
</script>

<style lang="scss">
.chat-container {
  width: calc(100vw - 310px);
}

@media (max-width: 768px) {
  .chat-container {
    width: 100%;
  }
}
</style>
